<!-- HEADER -->

<div class="modal-header border-0">
  <button
    type="button"
    class="btn-close"
    (click)="modal.dismiss()"
    gptDataTrack="swiper-close"
  >
    <i class="d-block gpicon-close"></i>
  </button>
</div>

<!-- CONTENT -->

<div class="image-swiper-modal-body custom-scroll-parent overflow-visible">
  <div #container class="modal-body custom-scroll gp-0 overflow-visible">
    <gpu-carousel
      class="h-100 flex-row overflow-visible"
      [transition]="'fade'"
      [tapEnabled]="isMobile ? true : false"
      (pageChange)="onPageChanged($event)"
    >
      <div *ngFor="let step of steps" gpuCarouselItem>
        <picture class="w-100">
          <source media="(min-width:769px)" [srcset]="step['img-l']" />
          <source media="(min-width:415px)" [srcset]="step['img-m']" />
          <img class="h-100 w-100 position-absolute" [src]="step['img-s']" />
        </picture>
        <div class="gradient-background"></div>
        <div
          class="carousel-content d-flex align-items-center justify-content-center w-100 gpx-32 gpx-sm-72 gpb-48 gpb-lg-80"
        >
          <p class="p1-semibold text-white text-center gmb-0">
            {{ step.text | translate }}
          </p>
        </div>
      </div>
      <gpu-carousel-controls
        [position]="'modal'"
        [controlsSize]="'extra_large'"
        [theme]="'mixed'"
      >
        <i
          class="d-none d-sm-block"
          gptDataTrack="swiper-left"
          gpuCarouselPrev
          [ngClass]="{ invisible: activePage === 0 }"
        ></i>
        <gpu-carousel-dots></gpu-carousel-dots>
        <i
          class="d-none d-sm-block"
          gptDataTrack="swiper-right"
          gpuCarouselNext
          [ngClass]="{ invisible: activePage === numberOfSlides - 1 }"
        ></i>
      </gpu-carousel-controls>
    </gpu-carousel>
  </div>
</div>
